import {setPointerPosition} from './setPointerPosition';
import {makeTabsClose} from './makeTabsClose';

export const initTabs = ( tabsContainer, slidersSplit ) => {
	if ( tabsContainer )
	{
		const tabs = Array.from( tabsContainer.querySelector( 'ul' ).children );
		const pointer = tabsContainer.querySelector( 'li.pointer' );
		let prevSlide = slidersSplit[0].slider;
		let prevTab = tabs[0];

		setPointerPosition( prevTab, pointer );
		
		const handleTabClick = ( {target} ) => {
			const currentTab = target.closest( 'li' );
			const tabIndex = tabs.indexOf( currentTab );

			if ( currentTab && tabIndex > -1 )
			{
				if ( prevTab && prevTab !== currentTab )
				{
					[prevTab, prevSlide].forEach( ( item ) => item.classList.remove( 'current' ) );
				}

				if ( !currentTab.classList.contains( 'current' ) )
				{
					[currentTab, slidersSplit[tabIndex].slider].forEach( ( item ) => item.classList.add( 'current' ) );
					tabsContainer.classList.remove( 'show-select' );
					
					slidersSplit[tabIndex].updateSlider();

					setPointerPosition( currentTab, pointer );

					prevTab = tabs[tabIndex];
					prevSlide = slidersSplit[tabIndex].slider;
					
					tabsContainer.setAttribute( 'data-current', currentTab.textContent );
				}
			}

			if ( window.innerWidth < 1024 && !currentTab )
			{
				tabsContainer.classList.toggle( 'show-select' );
			}

			const allSliders = Array.from( document.querySelectorAll( '.new-slider' ) );
			const sliderVisible = allSliders.find( el => el.classList.contains( 'current' ) );
			const btnPrev = sliderVisible.querySelector( '.prev' );
			if ( btnPrev.classList.contains( 'disabled' ) ) {
				btnPrev.click();
			}
		};
		
		tabsContainer.addEventListener( 'click', handleTabClick );

		document.addEventListener( 'click', makeTabsClose( tabsContainer ) );
		
		window.addEventListener( 'resize', () => {
			setPointerPosition( prevTab, pointer );
		} );
		
		/* При долгой загрузке страницы расчёт начального положения указателя происходит раньше,
			чем закончится перерисовка */
		window.addEventListener( 'load', () => {
			setPointerPosition( prevTab, pointer );
		} );
	}
};
